import { render, staticRenderFns } from "./MoreBlogPosts.vue?vue&type=template&id=37cd1a59&"
import script from "./MoreBlogPosts.vue?vue&type=script&lang=js&"
export * from "./MoreBlogPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports